import ActionMenu from './ActionMenu.component';

export default ActionMenu;
